import React from 'react';
import {
	A, Footer
} from 'gwx-voyager-components';

const ApplicationFooter = () => (
	<Footer>
		<A anchorStyle='nav-link ml-3' href='/contact' target='cerner_contact'>CONTACT US</A>
	</Footer>
);

export default ApplicationFooter;
